import { toast } from 'react-toastify'
import { CRASH_GAMES_TOAST_COLOR } from 'utils/constants/index'

export const setToasterColors = ({ bg, fill }) => {
  document.documentElement.style.setProperty('--exaToasterBg', bg)
  document.documentElement.style.setProperty('--exaToasterFill', fill)
}

export const openErrorToaster = ({ message, toasterId = '' }) => {
  setToasterColors(CRASH_GAMES_TOAST_COLOR.ERROR)

  toast.error(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    pauseOnFocusLoss: false,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}` // Use a combination of message and toasterId to uniquely identify the toaster,
    // preventing multiple toasters with the same message.
  })
}

export const openSuccessToaster = ({ message, toasterId = '' }) => {
  setToasterColors(CRASH_GAMES_TOAST_COLOR[window.location.pathname] || CRASH_GAMES_TOAST_COLOR.DEFAULT)

  toast.success(message, {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    pauseOnFocusLoss: false,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}` // Use a combination of message and toasterId to uniquely identify the toaster,
    // preventing multiple toasters with the same message.
  })
}

export const openInfoToaster = ({ message, toasterId = '' }) => {
  setToasterColors(CRASH_GAMES_TOAST_COLOR.INFO)

  toast.info(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    pauseOnFocusLoss: false,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}` // Use a combination of message and toasterId to uniquely identify the toaster,
    // preventing multiple toasters with the same message.
  })
}

export const openWarningToaster = ({ message, toasterId = '' }) => {
  toast.warn(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    pauseOnFocusLoss: false,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    toastId: `${message}${toasterId}` // Use a combination of message and toasterId to uniquely identify the toaster,
    // preventing multiple toasters with the same message.
  })
}
